import {
    Notification
} from 'element-ui';

const state = {
    resetForm: {
        email: '',
        code: '',
        password: '',
        passwordConfirmed: ''
    },
    reseted: true,
    disabled: true
};

const mutations = {
    setState(state, {
        key,
        data
    }) {
        state[key] = data;
    },
    clearForm: state => {
        return state.resetForm = {
            email: '',
            code: '',
            password: '',
            passwordConfirmed: ''
        }
    }
};

const actions = {
    // async resetPassword({state, commit}) {  
    //     const response = await axios.post(`${globalConfig.originalUrl}/restore/client`, state.resetForm);
    //     commit('setState', {key: 'reseted', data: false}); 
    //     return response.status === 200;
    // }, 

    async confirm({
        state
    }, {
        email,
        code
    }) {
        try {
            const response = await this.$api.public.confirm({
                email,
                code,
                type_app: 'web_client'
            });

            return response;
        } catch (e) {
            return false;
        }
    },

    async confirmEmail() {
        await this.$api.public.confirmEmail();
    },

    async getWorkload({}, data) {
        return await this.$api.public.getWorkload(data);
    }
};

const getters = {
    resetFormGetters: state => state.resetForm,
    isNotResetedGetters: state => state.reseted,
    disabledGetters: state => state.disabled
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}